import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Branching } from 'app/modules/domain/models/branching';
import { ConfigService } from 'app/utils/config-service';
import { Observable } from 'rxjs/Observable';
import { HelperMethods } from '../Helpers/herlperMethods';
@Injectable()
export class BranchingApiService {
  private branchingUrl: string;
  private branchingApi: string;
  private httpheader = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.branchingUrl = this.configService.getEnv('branchingApiTest');
    this.branchingApi = this.configService.getEnv('branchingApi');
  }
  getAllRoute() {
    return this.http.get<any>(this.branchingUrl + 'Route', {headers: this.httpheader});
 }
 getBranchingData(fromDate: Date, toDate: Date, jobId: string): Observable<{} | Branching > {
  let url = this.branchingApi + jobId + '/' + 'fromTo/' +  HelperMethods.formatDate(fromDate) + '/' + HelperMethods.formatDate(toDate) ;

  return this.http.get<Branching[]>(url)
      .map((result: any) => {
          let json = result;
          if (json) {
              return json ;
          }
      })
      .catch((error: any) => {
          throw error;
      });
}
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/components/branching-container/services/branching.api.service.ts